// import React, { useState } from "react";
// import { NavLink, Link } from "react-router-dom";
// import "./Navbar.css";

// function Navbar() {
//     const [menuOpen, setMenuOpen] = useState(false);
//     const [dropdownOpen, setDropdownOpen] = useState(false);

//     const toggleMenu = () => {
//         setMenuOpen(!menuOpen);
//     };

//     return (
//         <header className="navbar">
//             <div className="logo">
//                 <img src="/flytutor_logo.png" alt="FlyTutor Logo" />
//             </div>

//             {/* Hamburger Icon */}
//             <div className="menu-icon" onClick={toggleMenu}>
//                 {menuOpen ? "✖" : "☰"}
//             </div>

//             <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
//                 <li>
//                     <NavLink to="/" end onClick={() => setMenuOpen(false)} className={({ isActive }) => (isActive ? "active-link" : "")}>
//                         Home
//                     </NavLink>
//                 </li>

//                 {/* About with Dropdown */}
//                 <li
//                     className="dropdown"
//                     onMouseEnter={() => setDropdownOpen(true)}
//                     onMouseLeave={() => setDropdownOpen(false)}
//                 >
//                     <span className="dropdown-toggle">About ▾</span>
//                     {dropdownOpen && (
//                         <ul className="dropdown-menu">
//                             <li>
//                                 <NavLink
//                                     to="/about"
//                                     onClick={() => setMenuOpen(false)}
//                                     className={({ isActive }) => (isActive ? "active-link" : "")}
//                                 >
//                                     About Us
//                                 </NavLink>
//                             </li>
//                             <li>
//                                 <NavLink
//                                     to="/gallery"
//                                     onClick={() => setMenuOpen(false)}
//                                     className={({ isActive }) => (isActive ? "active-link" : "")}
//                                 >
//                                     Gallery
//                                 </NavLink>
//                             </li>
//                         </ul>
//                     )}
//                 </li>
//                 <li
//                     className="dropdown"
//                     onMouseEnter={() => setDropdownOpen(true)}
//                     onMouseLeave={() => setDropdownOpen(false)}
//                 >
//                     <span className="dropdown-toggle">Courses ▾</span>

//                     {dropdownOpen && (
//                         <ul className="dropdown-menu">
//                             <li>
//                                 <NavLink
//                                     to="/course"
//                                     onClick={() => setMenuOpen(false)}
//                                     className={({ isActive }) => (isActive ? "active-link" : "")}
//                                 >
//                                     DGCA Authorized Certificate
//                                 </NavLink>
//                             </li>
//                             <li>
//                                 <NavLink
//                                     to="/certificate"
//                                     onClick={() => setMenuOpen(false)}
//                                     className={({ isActive }) => (isActive ? "active-link" : "")}
//                                 >
//                                     Add On Courses
//                                 </NavLink>
//                             </li>
//                         </ul>
//                     )}
//                 </li>


//                 {/* <li>
//                     <NavLink to="/course" end onClick={() => setMenuOpen(false)} className={({ isActive }) => (isActive ? "active-link" : "")}>
//                         Courses
//                     </NavLink>
//                 </li>
//                 <li>
//                     <NavLink to="/certificate" onClick={() => setMenuOpen(false)} className={({ isActive }) => (isActive ? "active-link" : "")}>
//                         CertiFly
//                     </NavLink>
//                 </li> */}
//                 <li>
//                     <NavLink to="/contact" onClick={() => setMenuOpen(false)} className={({ isActive }) => (isActive ? "active-link" : "")}>
//                         Contact
//                     </NavLink>
//                 </li>
//             </ul>
//         </header>
//     );
// }

// export default Navbar;

import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const [coursesDropdownOpen, setCoursesDropdownOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="navbar">
      <div className="logo">
        <img src="/flytutor_logo.png" alt="FlyTutor Logo" />
      </div>

      {/* Hamburger Icon */}
      <div className="menu-icon" onClick={toggleMenu}>
        {menuOpen ? "✖" : "☰"}
      </div>

      <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
        <li>
          <NavLink
            to="/"
            end
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Home
          </NavLink>
        </li>

        {/* About with Dropdown */}
        <li
          className="dropdown"
          onMouseEnter={() => setAboutDropdownOpen(true)}
          onMouseLeave={() => setAboutDropdownOpen(false)}
        >
          <span className="dropdown-toggle">About ▾</span>
          {aboutDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <NavLink
                  to="/about"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/gallery"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  Gallery
                </NavLink>
              </li>
            </ul>
          )}
        </li>

        {/* Courses with Dropdown */}
        <li
          className="dropdown"
          onMouseEnter={() => setCoursesDropdownOpen(true)}
          onMouseLeave={() => setCoursesDropdownOpen(false)}
        >
          <span className="dropdown-toggle">Courses ▾</span>
          {coursesDropdownOpen && (
            <ul className="dropdown-menu">
              <li>
                <NavLink
                  to="/course"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  DGCA Authorized Certificate
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/certificate"
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => (isActive ? "active-link" : "")}
                >
                  Add On Courses
                </NavLink>
              </li>
            </ul>
          )}
        </li>

        <li>
          <NavLink
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            Contact
          </NavLink>
        </li>
      </ul>
    </header>
  );
}

export default Navbar;

